// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"c01f63b9","171":"e8236311"}[chunkId] + ".chunk.js";
};